export default __webpack_public_path__ + "static/media/lights.3293efa2.svg";